/* eslint-disable no-undef */
import Vue from 'vue';
import ApiUrl from '../apiurl';


export default {
    namespaced: true,
    state: {
    },
    getters: {

    },
    mutations: {

    },
    actions: {
        async getReportList({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.report.info, data);
                console.log(3000,data)
                handle && handle(rsp.data);
                  console.log(rsp.data)
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async createPort({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });

                const rsp = await axios.post(ApiUrl.report.create,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async deleteReport({commit},{data,handle}){

            try{
                commit('startLoading',null,{
                    root:true
                });
                 let data2= new FormData();
                data2.append('reportID',1716);
               
                  const rsp =await axios.post(ApiUrl.report.delete,data);
                // console.log(data,2000000000000)
                // console.log(rsp,1000000)
                handle && handle(rsp.data)

            } catch (e){
                console.error(e);
            } finally{
                commit('startLoading',null,{root:true})
            }
        },
        async querySearch({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.report.search, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async spaceSubmit({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.report.spaceSubmit, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async companySubmit({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.report.companySubmit, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async technologySubmit({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.report.techSubmit, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async filterAnaly({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.report.filterAnaly+ data.url, data.data1);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async filterAnaly1({commit}, {data,handle}){
            try {
                // commit('startLoading', null, {
                //     root: true
                // });
                const rsp = await axios.get(ApiUrl.report.filterAnaly+ data.url, data.data1);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                // commit('stopLoading', null, { root: true});
            }
        },
        async saveFilterAnaly({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.put(ApiUrl.report.filterAnaly+ data.url, null,data.data1);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async sendReportEmail({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.report.sendEmail+ data.url+'/send_email', data.data1);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async downLoadFile({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.report.download+ data.url+'/download', data.data1);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getProgress({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.report.download+ data.url+'/progress', data.data1);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async reloadFile({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.report.download+ data.url+'/reload', data.data1);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getDownLoadList({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.report.download+ data.url+'/download/list', data.data1);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
    }
}
